// extracted by mini-css-extract-plugin
module.exports = {"container":"_6410344d","distinction":"_e8e1ebd8","title":"_9f47dcaa","icon":"_dda0c01","goldDiamond":"_897d10ce","platinumDiamond":"_4cadd418"};